<script lang="ts">
  export let issues: Array<{ severity: 'error' | 'warning' | 'info'; message: string }> = [];

  const COLLAPSE_THRESHOLD = 5;
  let expanded = false;

  $: showToggle = issues.length > COLLAPSE_THRESHOLD;
  $: visibleIssues = showToggle && !expanded ? issues.slice(0, COLLAPSE_THRESHOLD) : issues;
</script>

<div class="error-panel" role="list" aria-label="Lista de problemas">
  {#each visibleIssues as issue, idx (idx)}
    <div class="error-panel__item error-panel__item--{issue.severity}" role="listitem">
      <span class="error-panel__badge">{issue.severity}</span>
      <span class="error-panel__message">{issue.message}</span>
    </div>
  {/each}

  {#if showToggle}
    <button
      class="error-panel__toggle"
      type="button"
      on:click={() => (expanded = !expanded)}
    >
      {expanded ? 'Mostrar menos' : `Ver mais ${issues.length - COLLAPSE_THRESHOLD} ocorrências`}
    </button>
  {/if}
</div>

<style>
  .error-panel {
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-2);
  }

  .error-panel__item {
    display: flex;
    align-items: baseline;
    gap: var(--ptt-space-2);
    padding: var(--ptt-space-2) var(--ptt-space-3);
    border-radius: var(--ptt-radius-sm);
    border-left: 3px solid transparent;
    font-size: 0.875rem;
  }

  .error-panel__item--error {
    border-left-color: var(--ptt-orange-100);
    background: color-mix(in srgb, var(--ptt-orange-100) 8%, var(--ptt-white));
  }

  .error-panel__item--warning {
    border-left-color: var(--ptt-yellow-200);
    background: color-mix(in srgb, var(--ptt-yellow-200) 8%, var(--ptt-white));
  }

  .error-panel__item--info {
    border-left-color: var(--ptt-blue-100);
    background: color-mix(in srgb, var(--ptt-blue-100) 8%, var(--ptt-white));
  }

  .error-panel__badge {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
  }

  .error-panel__item--error .error-panel__badge {
    color: var(--ptt-orange-100);
  }

  .error-panel__item--warning .error-panel__badge {
    color: var(--ptt-yellow-300);
  }

  .error-panel__item--info .error-panel__badge {
    color: var(--ptt-blue-100);
  }

  .error-panel__message {
    color: var(--ptt-gray-300);
  }

  .error-panel__toggle {
    align-self: flex-start;
    background: none;
    border: none;
    padding: var(--ptt-space-1) 0;
    font-family: var(--ptt-font-sans);
    font-size: 0.875rem;
    color: var(--ptt-purple-100);
    cursor: pointer;
    text-decoration: underline;
  }

  .error-panel__toggle:hover {
    color: var(--ptt-purple-200);
  }

  .error-panel__toggle:focus-visible {
    outline: none;
    box-shadow: var(--ptt-focus-ring);
    border-radius: var(--ptt-radius-sm);
  }
</style>
